import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SuperAdminContextModel } from '../../../../models/admin/super-admin-context.model';
import { SchoolModel } from '../../../../models/school/school.model';

@Component({
  selector: 'app-super-admin-banner',
  templateUrl: './super-admin-banner.component.html',
  styleUrls: ['./super-admin-banner.component.css']
})
export class SuperAdminBannerComponent {

  constructor(private router: Router) {}

  getSchoolName(): string {
    const ctx = SuperAdminContextModel.getContext();
    return ctx ? ctx.schoolName : '';
  }

  onExitClicked() {
    const ctx = SuperAdminContextModel.getContext();
    SuperAdminContextModel.removeContext();
    SchoolModel.removeCurrent();
    if (ctx && ctx.returnUrl) {
      this.router.navigateByUrl(ctx.returnUrl);
    } else {
      this.router.navigate(['admin', 'schools']);
    }
  }

}
